import * as Sentry from "@sentry/vue";
import Vue from "vue";
import type VueRouter from "vue-router";

const SENTRY_ID = import.meta.env.VITE_SENTRY_ID || "";
const SENTRY_ORIGINS = (import.meta.env.VITE_SENTRY_ORIGINS || "") as string;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || undefined;
const VUE_STAGE = import.meta.env.VITE_PRODUCT_STAGE || "PRD";

const tracingOrigins = SENTRY_ORIGINS.split(",") as (string | RegExp)[];
tracingOrigins.push(/^\//);

// true: sentryの利用設定がOFFの場合
const sentryDisable = () => SENTRY_ID === "";

// Traceサンプルレート。devやstagingだと1.0。productionは0.1ぐらいにする
const TRACES_SAMPLE_RATE = VUE_STAGE === "PRD" ? 0.1 : 1.0;

export default {
  init: (router: VueRouter) => {
    if (sentryDisable()) return;
    Sentry.init({
      Vue,
      dsn: SENTRY_ID,
      integrations: [
        // Tracingプラグイン
        Sentry.browserTracingIntegration({ router }),

        // Replayプラグイン
        Sentry.replayIntegration({ maskAllText: true, maskAllInputs: true }),
      ],
      tracePropagationTargets: tracingOrigins,
      // Tracing用オプション。devやstagingだと1.0。productionは0.1ぐらいにする
      tracesSampleRate: TRACES_SAMPLE_RATE,

      // Replay用オプション。エラー発生時のみ送るようにする
      replaysSessionSampleRate: 0, // 一般時はReplay時は取得しない
      replaysOnErrorSampleRate: 1.0, // エラー発生時は全部送る（発生１分前のデータから送信できる）

      environment: SENTRY_ENVIRONMENT,

      maxValueLength: 500, // エラー値の長さを最大500文字にする(標準は250)

      // for Vue3
      // logErrors: true,
      // trackComponents: true,

      // true: ブラウザのconsoleにSentryのデバッグ情報を流す
      // debug: false,
    });
  },

  sendSentry: (response: any): void => {
    if (response) {
      const msg =
        typeof response === "object" && "message" in response
          ? response.message
          : JSON.stringify(response);
      console.log(msg);
    }
    if (sentryDisable()) return;

    if (response) {
      const msg =
        typeof response === "object" && "message" in response
          ? response.message
          : JSON.stringify(response);
      Sentry.captureMessage(msg, "debug");
    }
  },

  sendSentryError: (error: any): void => {
    if (error) {
      if (error instanceof Error === false) {
        try {
          error = new Error(JSON.stringify(error));
        } catch (_err) {
          error = new Error(error);
        }
      }
      const msg = error.message;
      console.log(msg);
    }
    if (sentryDisable()) return;
    if (error) {
      Sentry.captureException(error);
    }
  },
};
